import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import i18n from '../i18n';
import { retrieveStorageById, patchStorage } from '../helpers/storeService';
import { useParams } from 'react-router';
import useRouting from '../hooks/useRouting';
import { ChatContext } from '../contexts/ChatContext';
import FlowChatBox from '../components/FlowChatBox';
import { getNestedObject } from '../helpers/objectService';

const FlowCarSecondHandMobile = () => {
  const { id, affinity, insuranceType, currentVehicle } = useParams();
  const { renderNextRoute } = useRouting();
  const { data } = retrieveStorageById(id, affinity, insuranceType) || {};
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    const question = {
      message: i18n.t('Did you buy this car <span>second-hand</span>?'),
      slug: 'second_hand_car',
    };
    addQuestion(question);
    loadDefaultValues();
  }, []);

  const loadDefaultValues = async () => {
    const defaultValuesTemp = {
      second_hand_car: getNestedObject(data, [
        'cars',
        [currentVehicle],
        'second_hand_car',
      ]),
      car_already_registered: getNestedObject(data, [
        'cars',
        [currentVehicle],
        'car_already_registered',
      ]),
    };
    setDefaultValues(defaultValuesTemp);
  };

  const submitHandler = () => {
    let car_information = {
      second_hand_car: defaultValues.second_hand_car,
    };
    patchStorage({
      payload: car_information,
      path: ['cars', [currentVehicle]],
      id,
      affinity,
      insuranceType,
    });

    const answer = {
      message: i18n.t(defaultValues.second_hand_car ? `Yes` : 'No'),
      slug: 'second_hand_car',
    };

    addAnswer(answer);

    if (defaultValues?.car_already_registered) {
      renderNextRoute(2, { vehicle: currentVehicle });
    } else {
      renderNextRoute(1, { vehicle: currentVehicle });
    }
  };

  return (
    <Container>
      <FlowChatBox />
      <RightContainer>
        <AddressToInsureQ>
          <StyledButton
            active={defaultValues.second_hand_car === true}
            onClick={() => {
              defaultValues.second_hand_car = true;
              submitHandler();
            }}
          >
            {i18n.t('Yes')}
          </StyledButton>
          <StyledButton
            active={defaultValues?.second_hand_car === false}
            onClick={() => {
              defaultValues.second_hand_car = false;
              submitHandler();
            }}
          >
            {i18n.t('No')}
          </StyledButton>
        </AddressToInsureQ>
      </RightContainer>
    </Container>
  );
};

const AddressToInsureQ = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  justify-content: center;
`;

const StyledButton = styled.button`
  background-color: ${({ active, theme }) =>
    active ? theme.brand.primary : '#ffffff'};
  border: ${({ active, theme }) =>
    active ? 'none' : `2px solid ${theme.brand.primary}`};
  border-radius: 5px;
  color: ${({ active, theme }) => (active ? '#ffffff' : theme.brand.primary)};
  cursor: pointer;
  font-weight: bold;
  font-size: 1.4rem;
  height: 4rem;
  &:focus {
    outline: 0;
  }
  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
    color: white;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  width: 100%;
  overflow: hidden;
`;

const RightContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 2rem;
`;

export default FlowCarSecondHandMobile;
